import { Component, Inject, Injector } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MaterialModule,JkBaseOption, JkDialogEditComponent, jkRestReturn } from 'jk-service';
import { JackBaseComponentModule } from 'jk-service';
import { AdvComModule } from "jk-advcom";
import { SysseService, templateUrlConfigSys } from '../_service_sys';
import { Sysse } from '../_entity_sys';


@Component({
  selector: 'app-sysse-edit',
  templateUrl: './sysse-editPkg.component.html',
  styleUrls: [],
  standalone: true,
  imports: [JackBaseComponentModule, AdvComModule,MaterialModule],
})

export class SysseEditComponent extends JkDialogEditComponent<SysseService,Sysse>{
  override srv!: SysseService;
  constructor(
    inject: Injector,
    public override dialogRef: MatDialogRef<SysseEditComponent>,
    @Inject(MAT_DIALOG_DATA)
    public override data: jkRestReturn
  ) {
    super(inject,dialogRef,data);
  }


}